<div class="my-activities-container p-4 flex flex-col gap-8">
  <div class="mb-4">
    <h1 class="text-2xl font-bold text-gray-900 mb-2">My Activities</h1>
  </div>

  <!-- Scheduled Activities -->
  <p-card>
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between p-4 border-b">
        <div class="flex items-center gap-3">
          <h2 class="text-lg font-semibold text-gray-900">Scheduled Activities</h2>
        </div>
        <p-button 
          label="Add Activity" 
          icon="pi pi-plus" 
          size="small"
          (onClick)="addActivity()"
          class="p-button-sm">
        </p-button>
      </div>
    </ng-template>
    
    <ng-template pTemplate="content">
      @if (scheduledLoading()) {
        <div class="flex justify-center items-center py-8">
          <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
        </div>
      } @else if (scheduledError()) {
        <div class="text-center py-8">
          <p class="text-red-600 mb-4">{{ scheduledError() }}</p>
          <p-button label="Retry" size="small" (onClick)="loadScheduledActivities()"></p-button>
        </div>
      } @else if (scheduledActivities().length === 0) {
        <div class="text-center py-8 text-gray-500">
          <p>No scheduled activities found</p>
        </div>
      } @else {
        <div class="overflow-x-auto">
          <p-table 
            [value]="scheduledActivities()" 
            [paginator]="true" 
            [rows]="10"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10, 25, 50]"
            styleClass="p-datatable-sm">
            
            <ng-template pTemplate="header">
              <tr>
                <app-table-headers [columns]="scheduledColumns()"></app-table-headers>
                <th class="text-center">Actions</th>
              </tr>
            </ng-template>
            
            <ng-template pTemplate="body" let-activity>
              <tr>
                <app-table-columns [columns]="scheduledColumns()" [data]="activity"></app-table-columns>
                <td class="text-center">
                  <div class="flex gap-1 justify-center">
                    <app-icon-button
                      [icon]="icons.solid.faCheck"
                      pTooltip="Complete Activity"
                      tooltipPosition="bottom"
                      buttonType="success"
                      size="sm"
                      (onClick)="completeActivity(activity)">
                    </app-icon-button>
                    <app-icon-button
                      [icon]="icons.solid.faPenToSquare"
                      pTooltip="Edit Activity"
                      tooltipPosition="bottom"
                      buttonType="info"
                      size="sm"
                      (onClick)="editActivity(activity)">
                    </app-icon-button>
                    <app-icon-button
                      [icon]="icons.solid.faTrashCan"
                      pTooltip="Delete Activity"
                      tooltipPosition="bottom"
                      buttonType="danger"
                      size="sm"
                      (onClick)="deleteActivityClick(activity)">
                    </app-icon-button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </ng-template>
  </p-card>

  <!-- Tagged Activities -->
  <p-card>
    <ng-template pTemplate="header">
      <div class="flex items-center gap-3 p-4 border-b">
        <h2 class="text-lg font-semibold text-gray-900">Tagged Activities</h2>
      </div>
    </ng-template>
    
    <ng-template pTemplate="content">
      @if (taggedLoading()) {
        <div class="flex justify-center items-center py-8">
          <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
        </div>
      } @else if (taggedError()) {
        <div class="text-center py-8">
          <p class="text-red-600 mb-4">{{ taggedError() }}</p>
          <p-button label="Retry" size="small" (onClick)="loadTaggedActivities()"></p-button>
        </div>
      } @else if (taggedActivities().length === 0) {
        <div class="text-center py-8 text-gray-500">
          <p>No tagged activities found</p>
        </div>
      } @else {
        <div class="overflow-x-auto">
          <p-table 
            [value]="taggedActivities()" 
            [paginator]="true" 
            [rows]="10"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10, 25, 50]"
            styleClass="p-datatable-sm">
            
            <ng-template pTemplate="header">
              <tr>
                <app-table-headers [columns]="taggedColumns()"></app-table-headers>
              </tr>
            </ng-template>
            
            <ng-template pTemplate="body" let-activity>
              <tr>
                <app-table-columns [columns]="taggedColumns()" [data]="activity"></app-table-columns>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </ng-template>
  </p-card>

  <!-- All Completed Activities -->
  <p-card>
    <ng-template pTemplate="header">
      <div class="flex items-center gap-3 p-4 border-b">
        <h2 class="text-lg font-semibold text-gray-900">Completed Activities</h2>
      </div>
    </ng-template>
    
    <ng-template pTemplate="content">
      @if (completedLoading()) {
        <div class="flex justify-center items-center py-8">
          <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
        </div>
      } @else if (completedError()) {
        <div class="text-center py-8">
          <p class="text-red-600 mb-4">{{ completedError() }}</p>
          <p-button label="Retry" size="small" (onClick)="loadCompletedActivities()"></p-button>
        </div>
      } @else if (completedActivities().length === 0) {
        <div class="text-center py-8 text-gray-500">
          <p>No completed activities found</p>
        </div>
      } @else {
        <div class="overflow-x-auto">
          <p-table 
            [value]="completedActivities()" 
            [paginator]="true" 
            [rows]="10"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10, 25, 50]"
            styleClass="p-datatable-sm">
            
            <ng-template pTemplate="header">
              <tr>
                <app-table-headers [columns]="completedColumns()"></app-table-headers>
                <th class="text-center">Actions</th>
              </tr>
            </ng-template>
            
            <ng-template pTemplate="body" let-activity>
              <tr>
                <app-table-columns [columns]="completedColumns()" [data]="activity"></app-table-columns>
                <td class="text-center">
                  <div class="flex gap-1 justify-center">
                    <app-icon-button
                      [icon]="icons.solid.faPenToSquare"
                      pTooltip="Edit Activity"
                      tooltipPosition="bottom"
                      buttonType="info"
                      size="sm"
                      (onClick)="editActivity(activity)">
                    </app-icon-button>
                    <app-icon-button
                      [icon]="icons.solid.faTrashCan"
                      pTooltip="Delete Activity"
                      tooltipPosition="bottom"
                      buttonType="danger"
                      size="sm"
                      (onClick)="deleteActivityClick(activity)">
                    </app-icon-button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </ng-template>
  </p-card>
</div>
